import { useAuth } from '@/user/hooks/useAuth'
import useUserMetadata from '@/user/hooks/useUserMetadata'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  CloseButton,
  HStack,
} from '@chakra-ui/react'
import { usePublishedReleasesQuery } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import settings from 'src/settings'
import { useWhatsNewPath } from '../hooks/useWhatsNewPath'
import { releaseToAnnounce } from '../release'

// #77 — « update done »: once per person, at the first visit after Yohan
// published a major version. Only its number and title: the page tells the
// rest. Purple, the brand colour, so it never reads as an alert.
export default function ReleaseBanner() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useAuth()
  const { metadata, setMetadata } = useUserMetadata()
  const { data } = usePublishedReleasesQuery()
  const whatsNewPath = useWhatsNewPath()

  const release = releaseToAnnounce(
    data?.release ?? [],
    user?.createdAt,
    metadata?.lastSeenRelease
  )
  if (!release || !metadata) return null

  const markSeen = () => setMetadata('lastSeenRelease', release.version)
  const handleOpen = () => {
    markSeen()
    navigate(whatsNewPath)
  }

  return (
    <Alert
      status="info"
      colorScheme="purple"
      alignItems="center"
      py={2}
      flexWrap="wrap"
      role="status"
    >
      <AlertIcon />
      <Box flex="1 1 260px" minW={0}>
        <AlertTitle>
          {t('ReleaseBanner.title', {
            brand: settings.brand.name,
            version: release.version.replace(/^v/, ''),
          })}
        </AlertTitle>
        {release.title && <AlertDescription>{release.title}</AlertDescription>}
      </Box>
      <HStack ml="auto" spacing={2}>
        <Button size="sm" colorScheme="purple" onClick={handleOpen}>
          {t('ReleaseBanner.open')}
        </Button>
        <CloseButton
          size="sm"
          aria-label={t('common.close')}
          onClick={markSeen}
        />
      </HStack>
    </Alert>
  )
}
